// Fonctions utilitaires pour créer des notifications

/**
 * Créer une notification pour un nouveau programme
 */
export const notifyNewProgramme = async (createNotification, programme, createdBy) => {
  return await createNotification({
    type: 'programme',
    title: 'Nouveau programme de culte',
    message: `Programme du ${programme.date} : ${programme.type}`,
    icon: 'Calendar',
    link: 'programmes',
    targetUsers: ['all'], // Visible par tous
    createdBy: createdBy
  });
};

/**
 * Créer une notification pour un nouveau cantique
 */
export const notifyNewFihirana = async (createNotification, fihirana, createdBy) => {
  return await createNotification({
    type: 'fihirana',
    title: 'Nouveau cantique ajouté',
    message: `${fihirana.number} - ${fihirana.title}`,
    icon: 'Music',
    link: 'fihirana',
    targetUsers: ['all'],
    createdBy: createdBy
  });
};

/**
 * Créer une notification pour une approbation en attente (admin uniquement)
 */
export const notifyPendingApproval = async (createNotification, user) => {
  return await createNotification({
    type: 'approval',
    title: 'Nouvelle inscription',
    message: `${user.name} attend l'approbation`,
    icon: 'Users',
    link: 'settings',
    targetUsers: ['admin'], // Visible par admin uniquement
    createdBy: 'system'
  });
};

/**
 * Créer une notification pour une annonce importante
 */
export const notifyAnnouncement = async (createNotification, announcement, createdBy) => {
  return await createNotification({
    type: 'announcement',
    title: announcement.title,
    message: announcement.message,
    icon: 'MessageSquare',
    link: announcement.link || 'dashboard',
    targetUsers: announcement.targetUsers || ['all'],
    createdBy: createdBy
  });
};

/**
 * Créer une notification pour un événement financier
 */
export const notifyFinancialEvent = async (createNotification, event, createdBy) => {
  return await createNotification({
    type: 'finance',
    title: event.title,
    message: event.message,
    icon: 'DollarSign',
    link: event.type === 'donation' ? 'donations' : 'expenses',
    targetUsers: ['admin', 'tresorier'], // Visible par admin et trésorier
    createdBy: createdBy
  });
};

/**
 * Créer une notification pour l'approbation d'un utilisateur
 */
export const notifyUserApproved = async (createNotification, userName, approvedUserId) => {
  return await createNotification({
    type: 'approval',
    title: 'Inscription approuvée',
    message: 'Votre inscription a été approuvée ! Vous pouvez maintenant vous connecter.',
    icon: 'Users',
    link: 'dashboard',
    targetUsers: [approvedUserId], // Visible uniquement par l'utilisateur approuvé
    createdBy: 'admin'
  });
};
